/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useEffect, useState } from 'react'
import { Grid, Typography } from '@mui/material'
import InnerHeadRoutes from 'components/Common/InnerHeadRoutes/InnerHeadRoutes';


import moment from 'moment';
import { AxiosPost, ResultAPI } from 'service/CommonFunction/TS_function';

/* Imports */
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";



am4core.addLicense("CH208466903");
am4core.useTheme(am4themes_animated);


const StatusPieChart = (props) => {

    const { sBA, data } = props

    useEffect(() => {
        if (data) {
            onRenderGraphPie(data);
        }
    }, [data])


    const onRenderGraphPie = (data) => {


        let chart = am4core.create("pie_avg", am4charts.PieChart);

        // Add data

        if (data.lstdata != null && data.lstdata.length > 0) {
            chart.data = data.lstdata;
            let label = chart.seriesContainer.createChild(am4core.Label);
            label.text = data.All;  // "1995";
            label.horizontalCenter = "middle";
            label.verticalCenter = "middle";
            label.fontSize = 25;

            // Add and configure Series
            let pieSeries = chart.series.push(new am4charts.PieSeries());
            pieSeries.dataFields.value = "value";
            pieSeries.dataFields.category = "name";
            pieSeries.innerRadius = am4core.percent(50);
            // pieSeries.ticks.template.disabled = true;
            // pieSeries.labels.template.disabled = true;
            pieSeries.slices.template.stroke = am4core.color("#fff");
            pieSeries.slices.template.strokeOpacity = 1;
            // pieSeries.slices.template.tooltipText = "{category}: {value.percent.formatNumber('#.00')}%";
            pieSeries.slices.template.tooltipText = "{category}: {value}, {sPercent}%";
            pieSeries.legendSettings.labelText = "{category}";
            pieSeries.labels.template.fontSize = 12;
            pieSeries.labels.template.paddingTop = 0;
            pieSeries.labels.template.paddingBottom = 0;
            // pieSeries.labels.template.text = "{value}, {value.percent.formatNumber('#.00')}%";
            pieSeries.labels.template.text = "{value}, {sPercent}%";
            pieSeries.labels.template.maxWidth = 150;
            pieSeries.labels.template.wrap = true;
            pieSeries.alignLabels = true;

            // This creates initial animation
            pieSeries.hiddenState.properties.opacity = 1;
            pieSeries.hiddenState.properties.endAngle = -90;
            pieSeries.hiddenState.properties.startAngle = -90;

            chart.hiddenState.properties.radius = am4core.percent(0);

            chart.legend = new am4charts.Legend();
            chart.legend.useDefaultMarker = true;
            chart.legend.labels.template.text = "{name}[/]";
            chart.legend.valueLabels.template.disabled = true;

            chart.legend.verticalCenter = "middle";

            var marker = chart.legend.markers.template.children.getIndex(0) as any;
            marker.cornerRadius(12, 12, 12, 12);
            marker.strokeWidth = 2;
            marker.strokeOpacity = 1;
            marker.stroke = am4core.color("#ccc");
        }
        else {
            chart.data = [{
                "country": "Dummy",
                "disabled": true,
                "value": 1000,
                "color": am4core.color("#dadada"),
                "opacity": 0.3,
                "strokeDasharray": "4,4",
                "tooltip": ""
            }];

            let label = chart.seriesContainer.createChild(am4core.Label);
            label.text = data.avg;  // "1995";
            label.horizontalCenter = "middle";
            label.verticalCenter = "middle";
            label.fontSize = 25;
            /* Create series */
            var series = chart.series.push(new am4charts.PieSeries());
            series.dataFields.value = "value";
            series.dataFields.category = "name";
            chart.innerRadius = am4core.percent(40);

            /* Set up slice appearance */
            var slice = series.slices.template;
            slice.propertyFields.fill = "color";
            slice.propertyFields.fillOpacity = "opacity";
            slice.propertyFields.stroke = "color";
            slice.propertyFields.strokeDasharray = "strokeDasharray";
            slice.propertyFields.tooltipText = "tooltip";

            series.labels.template.propertyFields.disabled = "disabled";
            series.ticks.template.propertyFields.disabled = "disabled";
        }




        setTimeout(() => {
            chart.exporting.getImage("png").then((data) => {
                let obj = {
                    id: 1,
                    sDesc: "pieAVG",
                    sName: "สถานะใบคำร้อง",
                    idDiv: 1,
                    imgBase64: data
                }
                props.exportImg && props.exportImg(obj);
            });
        }, 2000);
    }

    return (
        <>
            <Grid container spacing={1} direction="row" justifyContent="center" alignItems="start" >
                <Grid item xs={12}>
                    <Typography style={{ fontWeight: 500 }}>กลุ่มตลาด: {sBA}</Typography>
                </Grid>
                <Grid item xs={12}>
                    <div id="pie_avg" style={{ width: "100%", height: "450px" }}></div>
                </Grid>
            </Grid>
        </>
    )
}

export default StatusPieChart